export default "__VITE_ASSET__V9LSkSFe__"